import * as React from "react";

const MobileAccordian1 = ({ color = "#80FF00" }) => (
  <svg width={327} height={42} fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M326.211 23.962V1H15.671L1 14.92 1 41.79h311.937l13.274-17.828Z"
      fill="#070707"
    />
    <path
      d="M15.67 1 1 14.92v26.87h153.948m157.298 0 13.274-17.828V1H177.33"
      stroke={color}
      strokeWidth={0.386}
    />
  </svg>
);

export default MobileAccordian1;
